import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-didattica-universitaria',
  templateUrl: './didattica-universitaria.component.html',
  styleUrls: ['./didattica-universitaria.component.css']
})
export class DidatticaUniversitariaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
